<template lang="pug">
  div.wrap-module-profile-edit
    div.profile-edit-content.py28
      div.wrap-change-icon-photo.f.fc.mb8
        div.wrap-icon
          v-avatar(size="120").mb8
            v-img(:src="iconPhotoURL")
          div.wrap-changer.f.fh
            ItemChangeUserIconPhoto(:uid="user.uid" @updateImg="updateIconPhoto")
      v-text-field(v-model="lastName" label="姓" placeholder="山田" color="white")
      v-text-field(v-model="firstName" label="名" placeholder="太郎" color="white")
      v-textarea(v-model="profile" label="プロフィール" placeholder="自己紹介を記入"
        color="white" rows="8")
</template>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";

.wrap-module-profile-edit {
  padding-top: $header_height;
  .profile-edit-content {
    margin: 0 auto;
    width: $base_width_percent;
    max-width: $base_max_width_px;
    .wrap-change-icon-photo {
      .wrap-icon {
        position: relative;
        .wrap-changer {
          position: absolute;
          right: 8px; bottom: 8px;
          width: 32px; height: 32px;
          border-radius: 50%;
          background: $active_color;
        }
      }
    }
  }
}
</style>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapState: mapStateAuth } = createNamespacedHelpers('auth')
import ItemChangeUserIconPhoto from '@/components/item/ItemChangeUserIconPhoto'

export default {
  components: {
    ItemChangeUserIconPhoto
  },
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapStateAuth(['uid'])
  },
  data () {
    return {
      iconPhotoURL: '',
      firstName: '',
      lastName: '',
      profile: ''
    }
  },
  created () {
    this.iconPhotoURL = this.user.iconPhotoURL
    this.firstName = this.user.firstName
    this.lastName = this.user.lastName
    this.profile = this.user.profile
  },
  methods: {
    updateIconPhoto (url) {
      this.iconPhotoURL = url
    }
  }
}
</script>
